 document.addEventListener('DOMContentLoaded', function () {
  const partNumberLink = document.getElementById('show-part-number-selector');
  const productSelect = document.getElementById('product-select');
  const productSelectNew = document.getElementById('product-select-new'); 
  const productSelectLabel = document.querySelector('label[for="product-select"]');
  const productSpecificInfo = document.getElementById('product-specific-info');
  const yearMakeModelSearch = document.querySelector('.product-short__description');
  const productGallery = document.querySelector('.photos .swiper-wrapper'); // Update the selector to match your theme
  const productThumb = document.querySelector('.gallery-thumbs .swiper-wrapper'); // Update the selector to match your theme
  const priceRangeInfo = document.getElementById('price-range-info'); // Add an element to display price range
  const regularPrice = document.querySelector('.product-single__price'); // Update the selector to match your theme
  const skuElement = document.querySelector('.js-variant-sku'); // Add an element to display SKU
  const productvarint = document.querySelector('.product-form__variants'); // Element to display productvarint 
  const fitmentNotes = document.querySelector('#fitmentNotes');  // Fitment Notes
  const collectionhandle = document.querySelector('#collectionhandle').value;  // Fitment Notes
    const maindivprice = document.getElementById('maindivprice');
    const ProductDescription = document.getElementById('csmdesc'); 
      const sortDescr = document.getElementById('sortDesc'); 
   
   const variantAvailabilityElement = document.querySelector('.js-variant-availability'); // Add an element to display Availability
    const stockavailebele = document.querySelector('.stockavailebele'); // Add an element to display Availability
      const showsku = document.querySelector('.product-single__sku');

// Initialize the thumbnail swiper
var swiper = new Swiper(".mySwiper", {
    slidesPerView: 4,
    loop: false,
    spaceBetween: 10,
    freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
    breakpoints: {
        768: {
            slidesPerView: 6
        },
        640: {
            slidesPerView: 4
        }
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
});

// Initialize the main swiper with navigation and thumbnails
var swiper2 = new Swiper(".mySwiper2", {
    spaceBetween: 10,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
        nextEl: ".swiper-button-next",  // Navigation for main swiper
        prevEl: ".swiper-button-prev"
    },
    thumbs: {
        swiper: swiper  // Link thumbnails with the main swiper
    }
});

  




  let allProducts = [];

  partNumberLink.addEventListener('click', function (e) {
    e.preventDefault();
    productSelect.style.display = 'block';
    productSelectLabel.style.display = 'block';
    // if (yearMakeModelSearch) {
    //   yearMakeModelSearch.style.display = 'none';
    // }
  });


  // Fetch products from the RT Drop Steps collection
  const productsUrl = '/collections/' + collectionhandle + '/products.json?limit=250';
  fetch(productsUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status} while fetching ${productsUrl}`);
      }
      return response.json();
    })
    .then(data => {
      allProducts = data.products;
      let options = '<option value="" data-sku="ALL">Select Part Number</option>';
      let radioes = '';
      allProducts.forEach(product => {
        options += `<option data-sku="${product.variants[0].sku}" value="${product.id}">${product.variants[0].sku} - $${(product.variants[0].price / 1).toFixed(2)}</option>`;
        radioes += `<input type="radio" name="partradio"  data-sku="${product.variants[0].sku}" value="${product.id}">`;
      });
      // console.log(allProducts);
      productSelect.innerHTML = options;
      productSelectNew.innerHTML = radioes;

     // Calculate the lowest and highest prices
let lowestPrice = Infinity;
let highestPrice = -Infinity;

allProducts.forEach(product => {
  product.variants.forEach(variant => {
    const price = parseFloat(variant.price); // Ensure price is a number
    if (price < lowestPrice) lowestPrice = price;
    if (price > highestPrice) highestPrice = price;
  });
});

// Update the regular price display
regularPrice.innerHTML = `$${highestPrice.toFixed(2)}`;

// Display the price range
if (lowestPrice === highestPrice) {
  priceRangeInfo.innerHTML = `From $${highestPrice.toFixed(2)}`;
} else {
  priceRangeInfo.innerHTML = `From $${lowestPrice.toFixed(2)} - $${highestPrice.toFixed(2)}`;
  const savePrice = Math.abs(lowestPrice - highestPrice); // Ensure the value is positive
  document.querySelector('.save_price').innerHTML = `<span>You Save</span>&nbsp; $${savePrice.toFixed(2)}`;
}


      // Load the first product's details by default
      if (allProducts.length > 0) {
        loadProductDetails(allProducts[0].id);
      }
    })
    .catch(error => {
      console.error('Error fetching product list:', error);
    });

    productSelect.addEventListener('change', function () {
      const productId = this.value;
      if (productId) {
        const selectedProduct = allProducts.find(product => product.id == productId);



const selectedValue = this.value;

    // Get all the div elements with the class 'myproductids'
    const productDivs = document.querySelectorAll('.myproductids');

    // Loop through the divs and match the data-id with the selected value
    productDivs.forEach(div => {
      if (div.getAttribute('data-id') === selectedValue) {
        div.style.display = 'block'; // Show the matching div
      } else {
        div.style.display = 'none'; // Hide non-matching divs
      }
    });
        
        
        if (selectedProduct) {
          document.querySelector('.product-single__meta-price').style.display = 'flex';
          regularPrice.innerHTML = `$${(selectedProduct.variants[0].price / 1).toFixed(2)}`;
          document.querySelector('.product-tag-sale').innerHTML = `$${(selectedProduct.variants[0].compare_at_price / 1).toFixed(2)}`;
// Check if compare_at_price exists and is greater than 0
if (selectedProduct.variants[0].compare_at_price && selectedProduct.variants[0].compare_at_price > 0) {
  // Display both compare_at_price and regular price
  regularPrice.innerHTML = `
   
    <span class="regular-price">$${(selectedProduct.variants[0].price / 1).toFixed(2)}</span>
     <span class="compare-price">$${(selectedProduct.variants[0].compare_at_price / 1).toFixed(2)}</span>
  `;
} else {
  // If no compare_at_price, just display the regular price
regularPrice.innerHTML = `
    <span class="regular-price">$${(selectedProduct.variants[0].price / 1).toFixed(2)}</span>
  `;
}
          
          skuElement.innerHTML = selectedProduct.variants[0].sku;
   
           const cussku1 = selectedProduct.variants[0].sku;

document.querySelectorAll('.whole-sale-price .product-single__price').forEach(element => {
    const cussku2 = element.dataset.sku;
    if (cussku1 === cussku2) {
        element.style.display = 'flex';
       element.classList.remove('matched-sku');
    } else {
        element.style.display = 'none';
       element.classList.add('matched-sku');
    }
});
            showsku.style.display = 'block';
        priceRangeInfo.style.display = 'none'; // On change hide price range 
        
        const productMetafieldsElement = document.getElementById('productmetafileds');
        const myfitmentNotesText = JSON.parse(productMetafieldsElement.textContent);
        const fitmentNotes = myfitmentNotesText[selectedProduct.id].fitment_notes;
        const installation_instructions = myfitmentNotesText[selectedProduct.id].installation_instructions;
        const lifttimetext_instructions = myfitmentNotesText[selectedProduct.id].lifetime;
        const Videos1 = myfitmentNotesText[selectedProduct.id].Videos1;  
        const Videos2 = myfitmentNotesText[selectedProduct.id].Videos2;
        const summary = myfitmentNotesText[selectedProduct.id].summary;  
       

        if (Videos1 && Videos1.trim() !== "") {
           document.getElementById('iframe1').classList.remove('d-none');
           document.getElementById('iframe1').src = Videos1;
          } else {
    console.log("Videos1 is empty");
}
               if (Videos2 && Videos2.trim() !== "") {
           document.getElementById('iframe2').classList.remove('d-none');
          document.getElementById('iframe2').src = Videos2;
          } else {
    console.log("Videos1 is empty");
}

// Replacement Parts Code 

        
// Assume reppart contains comma-separated SKUs
const reppart = myfitmentNotesText[selectedProduct.id].reppart;

// Split the reppart into an array of SKUs
const skuArray = reppart.split(',');
console.log(skuArray);
// Get all elements with the class 'grid__item'
const gridItems = document.querySelectorAll('.related-products-wrapper .grid__item');

// Loop through each grid item
gridItems.forEach(item => {
    // Get the SKU from the data-sku attribute
    const itemSku = item.getAttribute('data-sku');
    
    // Check if itemSku is in the skuArray
    if (skuArray.includes(itemSku)) {
        // If it matches, set display to flex
        $('.replacement').removeClass('d-none');
        item.style.display = 'flex';
    } else {
        // If it doesn't match, set display to none
        item.style.display = 'none';
    }
});








        
 //End Code        
       const summaryElement = document.getElementById('summery');
        summaryElement.innerHTML = `Fitment Details: ${summary}`;
        const lifttimetext = document.querySelector(".lifetimetext").innerHTML = lifttimetext_instructions;
        const fitmentNotesElement = document.getElementById('fitmentNotes');
        fitmentNotesElement.innerHTML = fitmentNotes;
        if (installation_instructions) {
    document.querySelector('#installation_instructions').innerHTML = `Installation Instructions: <a href="${installation_instructions}" target="_blank">Click Here</a>`;
} else {
    document.querySelector('#installation_instructions').innerHTML = ''; // Clear the element or show an alternative message
}


        // Assuming you already have these variables
const inavantory = myfitmentNotesText[selectedProduct.id].invantory;
const mysku = selectedProduct.variants[0].sku;
  const productDescription = selectedProduct.body_html;
      if (productDescription) {
        ProductDescription.innerHTML = productDescription;
      } else {
        ProductDescription.innerHTML = 'No description available';
      }
  
      if (productDescription) {
        const truncatedDescription = productDescription.split(' ').slice(0, 20).join(' ') + '...';
        sortDescr.innerHTML = truncatedDescription;
      } else {
        
      }

          
// Target div where the hidden input will be appended (e.g., #backordernotes)
const backorderNotesDiv = document.querySelector(".backordernotes");
console.log(inavantory);
// Function to create and append the hidden input
function appendHiddenInput(name, value) {
    const inputElement = document.createElement('input');
    inputElement.type = 'hidden';
    inputElement.name = name;
    inputElement.value = value;

    // Append the input to the target div
    backorderNotesDiv.appendChild(inputElement);
}
// Function to remove the previously added hidden input
function removeHiddenInput(name) {
    const existingInput = backorderNotesDiv.querySelector(`input[name="${name}"]`);
    if (existingInput) {
        backorderNotesDiv.removeChild(existingInput);
    }
}
// Check if inventory is 0 or negative, and SKU starts with 'K'
if (inavantory <= 0 && mysku.startsWith('K')) {
    // Append hidden input for backordered items with SKU starting with 'K'
    appendHiddenInput("properties[Delayed Availability]", "One or more kit components for the item above are backordered, please call us for details.");
} else if (inavantory <= 0) {
    // Append hidden input for backordered items without SKU starting with 'K'
    appendHiddenInput("properties[Delayed Availability]", "The item above is backordered. You’ll receive an estimated ship date via email. Please call us for details.");
} else {
  
    // This block can be used if you want to handle any other conditions, e.g., when the item is in stock
  removeHiddenInput("properties[Delayed Availability]");
}

     function updateStockInfo(productId, inventory) {
    let stockButton = document.getElementById("warehouse-btn");
    let stockSpan = document.getElementById("stockavi");

    if (stockButton) {
        stockButton.setAttribute("data-product-id", productId);
       stockButton.style.display = "block"; 
    }
    if (stockSpan) {
        stockSpan.textContent = inventory;
    }
}

// Example usage
updateStockInfo(selectedValue,inavantory);  // Product ID: 12345, Inventory: 10

          
        // document.querySelector('#installation_instructions').innerHTML = `Installation Instructions: <a href="${installation_instructions}" target="_blank">Click Here</a>`;
        // document.querySelector('#availability').innerHTML = selectedProduct.variants[0].quantity;
        // variantAvailabilityElement.innerHTML = selectedProduct.variants[0].available;

             
              var addButton = document.querySelector("button.btn.product-form__cart-submit");
              var buttonText = document.querySelector("button.btn.product-form__cart-submit span");
                    console.log("nybcashcb",selectedProduct.variants[0].available);
              if (inavantory > 0) {
                
                  variantAvailabilityElement.innerHTML = '<span class="cus-avb-text">Availability:</span> <span class="in-stock">In Stock</span>';
            
                  addButton.classList.remove("btn--sold-out");
                  addButton.removeAttribute("disabled");
                  buttonText.textContent = "Add to Cart";
                  variantAvailabilityElement.classList.remove("out-of-stock");
                  variantAvailabilityElement.classList.add("in-stock");
              } else {
             
                  //variantAvailabilityElement.innerHTML = '<span class="cus-avb-text">Availability:</span> <span class="out-of-stock">Out of Stock</span>';
                 variantAvailabilityElement.innerHTML = '';
                  // addButton.classList.add("btn--sold-out");
                  // addButton.setAttribute("disabled", "disabled");
                  // buttonText.textContent = "Sold Out";
                  // variantAvailabilityElement.classList.remove("in-stock");
                  // variantAvailabilityElement.classList.add("out-of-stock");
              }

        

        
        document.getElementById('varintid').value = selectedProduct.variants[0].id;
        document.getElementById('sku').value = selectedProduct.variants[0].sku;
        document.querySelector('.product-button-variant').style.display = 'block';
        const images = selectedProduct.images.map((image, index) => `<div class="swiper-slide"><img src="${image.src}" class="myimage" alt="${selectedProduct.title}"></div>`).join('');
        const images2 = selectedProduct.images.map(image => `<div class="swiper-slide"><img src="${image.src}"  alt="${selectedProduct.title}"></div>`).join('');
        productGallery.innerHTML = images;
        productThumb.innerHTML = images2;
        productThumb.style.opacity  = '0';
          
      

        
        document.querySelector('.swiper-button-prev').style.display = 'none';
  
        
        
        document.querySelector('.swiper-button-next').style.display = 'none';
        
        setTimeout(function () {
           productThumb.style.opacity  = '1';
            document.querySelector('.swiper-button-prev').style.display = 'flex';
        document.querySelector('.swiper-button-next').style.display = 'flex';
          
// Initialize the thumbnail swiper
var swiper = new Swiper(".mySwiper", {
    slidesPerView: 4,
    loop: false,
    spaceBetween: 10,
    freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
    breakpoints: {
        768: {
            slidesPerView: 6
        },
        640: {
            slidesPerView: 4
        }
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
});

// Initialize the main swiper with navigation and thumbnails
var swiper2 = new Swiper(".mySwiper2", {
    spaceBetween: 10,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
        nextEl: ".swiper-button-next",  // Navigation for main swiper
        prevEl: ".swiper-button-prev"
    },
    thumbs: {
        swiper: swiper  // Link thumbnails with the main swiper
    }
});


         console.log("RunNow");




    const galleryImages = document.querySelectorAll('#lightgallery .myimage');
    const lightbox = document.getElementById('lightbox');
    const lightboxImage = document.getElementById('lightbox-image');
    const closeBtn = document.querySelector('.lightbox .close');
    const prevBtn = document.querySelector('.lightbox .prev');
    const nextBtn = document.querySelector('.lightbox .next');

    let currentIndex = 0;
    let isZoomedIn = false;

    // Ensure the lightbox is hidden on page load
    lightbox.style.display = 'none';

    const openLightbox = (index) => {
        currentIndex = index;
        lightboxImage.src = galleryImages[currentIndex].src;
        lightbox.style.display = 'flex';
        lightboxImage.style.transform = 'scale(1)';
    };

    const closeLightbox = () => {
        lightbox.style.display = 'none';
    };

    const showPrevImage = () => {
        currentIndex = (currentIndex === 0) ? galleryImages.length - 1 : currentIndex - 1;
        lightboxImage.src = galleryImages[currentIndex].src;
        resetZoom();
    };

    const showNextImage = () => {
        currentIndex = (currentIndex === galleryImages.length - 1) ? 0 : currentIndex + 1;
        lightboxImage.src = galleryImages[currentIndex].src;
        resetZoom();
    };

    const toggleZoom = () => {
        if (isZoomedIn) {
            lightboxImage.style.transform = 'scale(1)';
            lightboxImage.style.cursor = 'zoom-in';
        } else {
            lightboxImage.style.transform = 'scale(1.2)'; // Adjust this scale factor as needed
            lightboxImage.style.cursor = 'zoom-out';
        }
        isZoomedIn = !isZoomedIn;
    };

    const resetZoom = () => {
        isZoomedIn = false;
        lightboxImage.style.transform = 'scale(1)';
        lightboxImage.style.cursor = 'zoom-in';
    };

    galleryImages.forEach((image, index) => {
        image.addEventListener('click', () => openLightbox(index));
    });

    closeBtn.addEventListener('click', closeLightbox);
    prevBtn.addEventListener('click', showPrevImage);
    nextBtn.addEventListener('click', showNextImage);

    lightboxImage.addEventListener('click', toggleZoom);

    lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) {
            closeLightbox();
        }
    });













          
     }, 1500);
        
        loadProductDetails(productId);
      }
    }
  });



   
   
// FOR YMM MODEL RADIO BUTTON
  setTimeout(function () {
// Add event listener to all radio buttons with the name 'partradio'
document.querySelectorAll('input[name="partradio"]').forEach(radioButton => {
    radioButton.addEventListener('change', function () {
       // This is for debugging; remove or replace as needed

        const productId = this.value;  // Assuming the value of the button is the product ID
        if (productId) {
            const selectedProduct = allProducts.find(product => product.id == productId);




          const selectedValue = this.value;

          

    // Get all the div elements with the class 'myproductids'
    const productDivs = document.querySelectorAll('.myproductids');

    // Loop through the divs and match the data-id with the selected value
    productDivs.forEach(div => {
      if (div.getAttribute('data-id') === selectedValue) {
        div.style.display = 'block'; // Show the matching div
      } else {
        div.style.display = 'none'; // Hide non-matching divs
      }
    });
            if (selectedProduct) {
                document.querySelector('.product-single__meta-price').style.display = 'flex';
                regularPrice.innerHTML = `$${(selectedProduct.variants[0].price / 1).toFixed(2)}`;
                document.querySelector('.product-tag-sale').innerHTML = `$${(selectedProduct.variants[0].compare_at_price / 1).toFixed(2)}`;
              // Check if compare_at_price exists and is greater than 0
if (selectedProduct.variants[0].compare_at_price && selectedProduct.variants[0].compare_at_price > 0) {
  // Display both compare_at_price and regular price
  regularPrice.innerHTML = `
   
    <span class="regular-price">$${(selectedProduct.variants[0].price / 1).toFixed(2)}</span>
     <span class="compare-price">$${(selectedProduct.variants[0].compare_at_price / 1).toFixed(2)}</span>
  `;
} else {
  // If no compare_at_price, just display the regular price
regularPrice.innerHTML = `
    <span class="regular-price">$${(selectedProduct.variants[0].price / 1).toFixed(2)}</span>
  `;
}
                skuElement.innerHTML = selectedProduct.variants[0].sku;

                const cussku1 = selectedProduct.variants[0].sku;

                document.querySelectorAll('.whole-sale-price .product-single__price').forEach(element => {
                    const cussku2 = element.dataset.sku;
                    if (cussku1 === cussku2) {
                        element.style.display = 'flex';
                        element.classList.remove('matched-sku');
                    } else {
                        element.style.display = 'none';
                        element.classList.add('matched-sku');
                    }
                });
   priceRangeInfo.style.display = 'none'; // On change hide price range 
                  showsku.style.display = 'block';
                const productMetafieldsElement = document.getElementById('productmetafileds');
                const myfitmentNotesText = JSON.parse(productMetafieldsElement.textContent);
                const fitmentNotes = myfitmentNotesText[selectedProduct.id].fitment_notes;
                const installation_instructions = myfitmentNotesText[selectedProduct.id].installation_instructions;
                const lifttimetext_instructions = myfitmentNotesText[selectedProduct.id].lifetime;
                const lifttimetext = document.querySelector(".lifetimetext").innerHTML = lifttimetext_instructions;
                const fitmentNotesElement = document.getElementById('fitmentNotes');
                 const Videos1 = myfitmentNotesText[selectedProduct.id].Videos1;  
        const Videos2 = myfitmentNotesText[selectedProduct.id].Videos2;  
                 const summary = myfitmentNotesText[selectedProduct.id].summary;  
       
              
        if (installation_instructions) {
    document.querySelector('#installation_instructions').innerHTML = `Installation Instructions: <a href="${installation_instructions}" target="_blank">Click Here</a>`;
} else {
    document.querySelector('#installation_instructions').innerHTML = ''; // Clear the element or show an alternative message
}
        if (Videos1 && Videos1.trim() !== "") {
           document.getElementById('iframe1').classList.remove('d-none');
           document.getElementById('iframe1').src = Videos1;
          } else {
    console.log("Videos1 is empty");
}
               if (Videos2 && Videos2.trim() !== "") {
           document.getElementById('iframe2').classList.remove('d-none');
          document.getElementById('iframe2').src = Videos2;
          } else {
    console.log("Videos1 is empty");
}

// Replacement Parts Code 

        
// Assume reppart contains comma-separated SKUs
const reppart = myfitmentNotesText[selectedProduct.id].reppart;

// Split the reppart into an array of SKUs
const skuArray = reppart.split(',');
console.log(skuArray);
// Get all elements with the class 'grid__item'
const gridItems = document.querySelectorAll('.related-products-wrapper .grid__item');

// Loop through each grid item
gridItems.forEach(item => {
    // Get the SKU from the data-sku attribute
    const itemSku = item.getAttribute('data-sku');
    
    // Check if itemSku is in the skuArray
    if (skuArray.includes(itemSku)) {
        // If it matches, set display to flex
        $('.replacement').removeClass('d-none');
        item.style.display = 'flex';
    } else {
        // If it doesn't match, set display to none
        item.style.display = 'none';
    }
});









        
 //End Code        
   const summaryElement = document.getElementById('summery');
        summaryElement.innerHTML = `Fitment Details: ${summary}`;
        // Assuming you already have these variables
const inavantory = myfitmentNotesText[selectedProduct.id].invantory;
const mysku = selectedProduct.variants[0].sku;

  const productDescription = selectedProduct.body_html;
      if (productDescription) {
        ProductDescription.innerHTML = productDescription;
      } else {
        ProductDescription.innerHTML = 'No description available';
      }
  
      if (productDescription) {
        const truncatedDescription = productDescription.split(' ').slice(0, 20).join(' ') + '...';
        sortDescr.innerHTML = truncatedDescription;
      } else {
        
      }

              
// Target div where the hidden input will be appended (e.g., #backordernotes)
const backorderNotesDiv = document.querySelector(".backordernotes");
console.log(inavantory);
// Function to create and append the hidden input
function appendHiddenInput(name, value) {
    const inputElement = document.createElement('input');
    inputElement.type = 'hidden';
    inputElement.name = name;
    inputElement.value = value;

    // Append the input to the target div
    backorderNotesDiv.appendChild(inputElement);
}
// Function to remove the previously added hidden input
function removeHiddenInput(name) {
    const existingInput = backorderNotesDiv.querySelector(`input[name="${name}"]`);
    if (existingInput) {
        backorderNotesDiv.removeChild(existingInput);
    }
}
// Check if inventory is 0 or negative, and SKU starts with 'K'
if (inavantory <= 0 && mysku.startsWith('K')) {
    // Append hidden input for backordered items with SKU starting with 'K'
    appendHiddenInput("properties[Delayed Availability]", "One or more kit components for the item above are backordered, please call us for details.");
} else if (inavantory <= 0) {
    // Append hidden input for backordered items without SKU starting with 'K'
    appendHiddenInput("properties[Delayed Availability]", "The item above is backordered. You’ll receive an estimated ship date via email. Please call us for details.");
} else {
  
    // This block can be used if you want to handle any other conditions, e.g., when the item is in stock
  removeHiddenInput("properties[Delayed Availability]");
}
       



   function updateStockInfo(productId, inventory) {
    let stockButton = document.getElementById("warehouse-btn");
    let stockSpan = document.getElementById("stockavi");

    if (stockButton) {
        stockButton.setAttribute("data-product-id", productId);
       stockButton.style.display = "block"; 
    }
    if (stockSpan) {
        stockSpan.textContent = inventory;
    }
}

// Example usage
updateStockInfo(selectedValue,inavantory);  

              
                fitmentNotesElement.innerHTML = fitmentNotes;
                document.querySelector('#installation_instructions').innerHTML = `Installation Instructions: <a href="${installation_instructions}" target="_blank">Click Here</a>`;
                // document.querySelector('#availability').innerHTML = selectedProduct.variants[0].quantity;
                // variantAvailabilityElement.innerHTML = selectedProduct.variants[0].available;

                var addButton = document.querySelector("button.btn.product-form__cart-submit");
                var buttonText = document.querySelector("button.btn.product-form__cart-submit span");
              
                if (inavantory > 0) {
                    variantAvailabilityElement.innerHTML = '<span class="cus-avb-text">Availability:</span> <span class="in-stock">In Stock</span>';
                    addButton.classList.remove("btn--sold-out");
                    addButton.removeAttribute("disabled");
                    buttonText.textContent = "Add to Cart";
                    variantAvailabilityElement.classList.remove("out-of-stock");
                    variantAvailabilityElement.classList.add("in-stock");
                } else {
                    //variantAvailabilityElement.innerHTML = '<span class="cus-avb-text">Availability:</span> <span class="out-of-stock">Out of Stock</span>';
                  variantAvailabilityElement.innerHTML = '';
                    addButton.classList.add("btn--sold-out");
                    // addButton.setAttribute("disabled", "disabled");
                    // buttonText.textContent = "Sold Out";
                    // variantAvailabilityElement.classList.remove("in-stock");
                    // variantAvailabilityElement.classList.add("out-of-stock");
                }

 
                document.getElementById('varintid').value = selectedProduct.variants[0].id;
                document.getElementById('sku').value = selectedProduct.variants[0].sku;
                document.querySelector('.product-button-variant').style.display = 'block';
        const images = selectedProduct.images.map((image, index) => `<div class="swiper-slide"><img src="${image.src}" class="myimage" alt="${selectedProduct.title}"></div>`).join('');
        const images2 = selectedProduct.images.map(image => `<div class="swiper-slide"><img src="${image.src}"  alt="${selectedProduct.title}"></div>`).join('');
        productGallery.innerHTML = images;
        productThumb.innerHTML = images2;
                productThumb.style.opacity = '0';

                document.querySelector('.swiper-button-prev').style.display = 'none';
                document.querySelector('.swiper-button-next').style.display = 'none';

                setTimeout(function () {
                    productThumb.style.opacity = '1';
                    document.querySelector('.swiper-button-prev').style.display = 'flex';
                    document.querySelector('.swiper-button-next').style.display = 'flex';

    // Initialize the thumbnail swiper
var swiper = new Swiper(".mySwiper", {
    slidesPerView: 4,
    loop: false,
    spaceBetween: 10,
    freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
    breakpoints: {
        768: {
            slidesPerView: 6
        },
        640: {
            slidesPerView: 4
        }
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
});

// Initialize the main swiper with navigation and thumbnails
var swiper2 = new Swiper(".mySwiper2", {
    spaceBetween: 10,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
        nextEl: ".swiper-button-next",  // Navigation for main swiper
        prevEl: ".swiper-button-prev"
    },
    thumbs: {
        swiper: swiper  // Link thumbnails with the main swiper
    }
});

                    console.log("RunNow");
    





    const galleryImages = document.querySelectorAll('#lightgallery .myimage');
    const lightbox = document.getElementById('lightbox');
    const lightboxImage = document.getElementById('lightbox-image');
    const closeBtn = document.querySelector('.lightbox .close');
    const prevBtn = document.querySelector('.lightbox .prev');
    const nextBtn = document.querySelector('.lightbox .next');

    let currentIndex = 0;
    let isZoomedIn = false;

    // Ensure the lightbox is hidden on page load
    lightbox.style.display = 'none';

    const openLightbox = (index) => {
        currentIndex = index;
        lightboxImage.src = galleryImages[currentIndex].src;
        lightbox.style.display = 'flex';
        lightboxImage.style.transform = 'scale(1)';
    };

    const closeLightbox = () => {
        lightbox.style.display = 'none';
    };

    const showPrevImage = () => {
        currentIndex = (currentIndex === 0) ? galleryImages.length - 1 : currentIndex - 1;
        lightboxImage.src = galleryImages[currentIndex].src;
        resetZoom();
    };

    const showNextImage = () => {
        currentIndex = (currentIndex === galleryImages.length - 1) ? 0 : currentIndex + 1;
        lightboxImage.src = galleryImages[currentIndex].src;
        resetZoom();
    };

    const toggleZoom = () => {
        if (isZoomedIn) {
            lightboxImage.style.transform = 'scale(1)';
            lightboxImage.style.cursor = 'zoom-in';
        } else {
            lightboxImage.style.transform = 'scale(1.2)'; // Adjust this scale factor as needed
            lightboxImage.style.cursor = 'zoom-out';
        }
        isZoomedIn = !isZoomedIn;
    };

    const resetZoom = () => {
        isZoomedIn = false;
        lightboxImage.style.transform = 'scale(1)';
        lightboxImage.style.cursor = 'zoom-in';
    };

    galleryImages.forEach((image, index) => {
        image.addEventListener('click', () => openLightbox(index));
    });

    closeBtn.addEventListener('click', closeLightbox);
    prevBtn.addEventListener('click', showPrevImage);
    nextBtn.addEventListener('click', showNextImage);

    lightboxImage.addEventListener('click', toggleZoom);

    lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) {
            closeLightbox();
        }
    });





                  
                  
                }, 1500);

                loadProductDetails(productId);
            }
        }
    });
});
}, 1500);
   
   
// END YMM MODEL CODE FOR RADIO   


  function loadProductDetails(productId) {
    const product = allProducts.find(p => p.id == productId);
    if (!product) {
      console.error(`Product with ID ${productId} not found`);
      return;
    }

    // Extract necessary details from the product object

    const fitmentChart = product.fitment_chart ? `<div>${product.fitment_chart}</div>` : ''; // Ensure this data is available
    const installSheets = product.install_sheets ? `<div>${product.install_sheets}</div>` : ''; // Ensure this data is available
    const videos = product.videos ? product.videos.map(video => `<video src="${video.src}" controls></video>`).join('') : '';

    // Debugging: Check if elements are correctly updated
    // console.log('Updating productGallery with images:', images);
    //console.log('Updating productSpecificInfo with fitmentChart, installSheets, videos:', fitmentChart, installSheets, videos);

    // Update the main product gallery with all product images


    // Update additional product-specific information
    productSpecificInfo.innerHTML = `
      ${fitmentChart}
      ${installSheets}
      ${videos}
    `;
  }
});
    // const productSelect = document.getElementById('product-select');
    // const listItems = document.querySelectorAll('.link-listing li');

    // productSelect.addEventListener('change', () => {
    //     const selectedSku = productSelect.options[productSelect.selectedIndex].dataset.sku;
    //     listItems.forEach(item => {
    //          if (selectedSku === 'ALL' || item.classList.contains(selectedSku)) {
    //             item.style.display = 'block';
    //         } else {
    //             item.style.display = 'none';
    //         }
    //     });
    // });

    // // Initial setup to show all items if no selection is made
    // productSelect.dispatchEvent(new Event('change'));






// Start Fitement Tab JavaScript  


var skuArray = [];

// Collect all SKUs on page load
setTimeout(function() {
  $('input[name="partradio"]').each(function() {
    var sku = $(this).data('sku');
    skuArray.push(sku);
  });
  console.log('Collected SKUs:', skuArray);
  matchAndShowData(skuArray);
}, 2000);

async function fetchCSVData() {
  try {
    const response = await fetch('https://cdn.shopify.com/s/files/1/0867/6088/2464/files/all_product_fitment_202503051311.csv?v=1742995172');
    const csvData = await response.text();
    return csvData;
  } catch (error) {
    console.error('Error fetching CSV:', error);
    return null;
  }
}

function parseCSV(csvData) {
  const rows = csvData.split('\n');
  const headers = rows[0].split(',');
  const csvContent = rows.slice(1).map(row => row.split(',').map(cell => cell.trim())); // Trim each cell
  //console.log('Parsed CSV Data:', csvContent);
  return csvContent;
}

function removeDuplicates(data) {
  const uniqueRows = [];
  const uniqueKeys = new Set();

  data.forEach(row => {
    const key = `${row[0]}-${row[1]}-${row[2]}`; // Create a unique key for year, make, and model
    if (!uniqueKeys.has(key)) {
      uniqueKeys.add(key);
      uniqueRows.push(row);
    }
  });

  return uniqueRows;
}

function sortData(data) {
  return data.sort((a, b) => {
    if (a[1] < b[1]) return -1; // Sort by Make (Ascending)
    if (a[1] > b[1]) return 1;
    if (a[2] < b[2]) return -1; // Sort by Model (Ascending)
    if (a[2] > b[2]) return 1;
    if (a[0] > b[0]) return -1; // Sort by Year (Descending)
    if (a[0] < b[0]) return 1;
    return 0;
  });
}

function displayData(tbody, matchedData) {
  tbody.innerHTML = ''; // Clear existing rows

  const uniqueData = removeDuplicates(matchedData);
  const sortedData = sortData(uniqueData); // Sort the data

  let hasUniversal = false;

  if (sortedData.length > 0) {
    sortedData.forEach(row => {
      if (row[0].toLowerCase() === 'universal' || row[1].toLowerCase() === 'universal' || row[2].toLowerCase() === 'universal') {
        hasUniversal = true;
      }

      const tr = document.createElement('tr');
      const makeCell = document.createElement('td');
      const modelCell = document.createElement('td');
      const yearCell = document.createElement('td');

      makeCell.textContent = row[1];  // Make in column 1
      modelCell.textContent = row[2]; // Model in column 2
      yearCell.textContent = row[0];  // Year in column 0

      tr.appendChild(makeCell);
      tr.appendChild(modelCell);
      tr.appendChild(yearCell);

      tbody.appendChild(tr);
    });
  } else {
    const tr = document.createElement('tr');
    const noDataCell = document.createElement('td');
    noDataCell.textContent = 'No data found for selected part number';
    noDataCell.colSpan = 3; // Span across all table columns

    tr.appendChild(noDataCell);
    tbody.appendChild(tr);
  }

  if (hasUniversal) {
    $(".fitmentdataClass").hide();
  } else {
    $(".fitmentdataClass").show();
  }
}

async function matchAndShowData(skuArray) {
  const csvData = await fetchCSVData();
  if (!csvData) return;

  const csvContent = parseCSV(csvData);
  const tbody = document.querySelector('#linkListing tbody');

  const initialMatchedData = csvContent.filter(row => skuArray.includes(row[6]));
  //console.log('Initial Matched Data:', initialMatchedData);
  displayData(tbody, initialMatchedData);

  // Event listener for the product select dropdown
  $('#product-select').on('change', function() {
    const selectedOption = $(this).find(':selected').data('sku').trim();
    const matchedData = csvContent.filter(row => row[6] === selectedOption);
    console.log('Matched Data for Selected Option:', matchedData);
    displayData(tbody, matchedData);
  });

  // Event listener for the submodel dropdowns
  $('.submodelDropdown, .submodel2Dropdown, .submodel3Dropdown').on('change', function() {
    setTimeout(function() {
      var hiddenInputValue = $('input[name="mypartnumber"]').val();

      // Check if the hidden input value is not blank
      if (hiddenInputValue) {
        // Use the hidden input value as the SKU
        var selectedSku = hiddenInputValue;
        const matchedData = csvContent.filter(row => row[6] === selectedSku);
        //console.log('Matched Data for Hidden Input Value:', matchedData);
        // Run the displayData function with the hidden input value
        displayData(tbody, matchedData);

        // Log the hidden input value for verification
        console.log("Hidden Input Value:", hiddenInputValue);
      } else {
        console.log("Hidden input value is blank.");
      }
    }, 1000);
  });
}



function searchTable() {
    var input, filter, table, tr, td, i, txtValue;
    input = document.getElementById("searchInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("linkListing");
    tr = table.getElementsByTagName("tr");

    for (i = 1; i < tr.length; i++) {
      tr[i].style.display = "none";
      td = tr[i].getElementsByTagName("td");
      for (var j = 0; j < td.length; j++) {
        if (td[j]) {
          txtValue = td[j].textContent || td[j].innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = "";
            break;
          }
        }
      }
    }
  }
// End Fitment Tab JavaScript 




// Start Item Specs Tab JavaScript 
 $(".itemspecsData").hide();
      setTimeout(function() {

            var allData = [];
            var transposedData = {};
            var skuArray = [];

            // Collect all SKUs on page load
            $('input[name="partradio"]').each(function() {
                var sku = $(this).data('sku');
                skuArray.push(sku);
            });

            // Log the SKU array to the console for verification
            console.log('arraySKU',skuArray);

            // Load the CSV file
            Papa.parse('https://cdn.shopify.com/s/files/1/0867/6088/2464/files/CYC_Product_Specs_Item_Specs_Product_Tab.csv?v=1730395567', {
                download: true,
                header: true,
                complete: function(results) {
                    allData = results.data;
                  if(skuArray.length === 1)
                  {
                    displayData(allData, skuArray);
                    $(".itemspecsData").show();
                  }
                  else
                  {
                    displayData(allData, skuArray);
                  }
                }
            });

            // Function to display data in the table
            function displayData(data, skus) {
                var tableBody = $('#data-table tbody');
                tableBody.empty();

                // Add custom headers - SB 10-30-2024
                $('#data-table thead').html(`
                    <tr>
                        <th>SPECIFICATION</th>
                        <th>DETAILS</th>
                    </tr>
                `);

                // Filter data based on the SKUs
                var matchedData = data.filter(function(row) {
                    return skus.includes(row.MPN);
                });

                if (matchedData.length === 0) {
                    tableBody.append('<tr><td colspan="2">No matching data found</td></tr>');
                    $(".itemspecsData").hide();
                  $(".itemspecsData").css('visibility','hidden');
                   $(".itemspecsData").css('width','0px');
                   $(".itemspecsData").css('margin','0px');
                    return;
                }

                // Take the first matched data
                var firstMatchedData = matchedData[0];

                // Transpose the data
                transposedData = {};
                for (var key in firstMatchedData) {
                    if (!transposedData[key]) {
                        transposedData[key] = [];
                    }
                    transposedData[key].push(firstMatchedData[key]);
                }

                // Display transposed data
                for (var key in transposedData) {
                    var values = transposedData[key];
                    var valuesStr = values.join(', ');
                    var rowHtml = '<tr data-row="' + key + '">' +
                                  '<td>' + key + '</td>' +
                                  '<td>' + valuesStr + '</td>' +
                                  '</tr>';
                    tableBody.append(rowHtml);

                    // Check if the entire row should be hidden
                    var shouldHide = values.every(function(value) {
                        return value.trim() === '' || value.toLowerCase().trim() === 'n/a';
                    });

                    if (shouldHide) {
                      
                        $('tr[data-row="' + key + '"]').addClass('hidden-row');
                    }
                }
            }

            // Event listener for the select box
            $('#product-select').on('change', function() {
                var selectedSku = $(this).find(':selected').data('sku');
                if (selectedSku === "ALL") {
                    displayData(allData, skuArray);
                } else {
                    displayData(allData, [selectedSku]);
                   $(".itemspecsData").show();
                }
            });

            // Event listener for the submodel dropdowns
            $('.submodel2Dropdown, .submodel3Dropdown').on('change', function() {
                setTimeout(function() {
                    var hiddenInputValue = $('input[name="mypartnumber"]').val();

                    // Check if the hidden input value is not blank
                    if (hiddenInputValue) {
                        // Use the hidden input value as the SKU
                        var selectedSku = hiddenInputValue;

                        // Run the displayData function with the hidden input value
                        displayData(allData, [selectedSku]);
                         $(".itemspecsData").show();
                        // Log the hidden input value for verification
                        console.log("Hidden Input Value:", hiddenInputValue);
                    } else {
                        console.log("Hidden input value is blank.");
                    }
                }, 1000);
            });
        }, 2000);

// End Item Specs Tab JavaScript 



    $(document).ready(function() {
        setTimeout(function() {
            // Load the CSV file
            var csvUrl = 'https://cdn.shopify.com/s/files/1/0867/6088/2464/files/all_product_fitment_202503051311.csv?v=1742995172';
            
            $.get(csvUrl, function(data) {
                // Parse the CSV data
                Papa.parse(data, {
                    header: true,
                    complete: function(results) {
                        var products = results.data;
                        
                        // Retrieve data from selectedData in local storage
                        var selectedDataStr = localStorage.getItem('permanentSelectedData');
                        var selectedDatanew = JSON.parse(selectedDataStr);
                        
                        if (selectedDatanew) {
                            // Extract values from selectedData
                            var year = selectedDatanew.year;
                            var make = selectedDatanew.make;
                            var model = selectedDatanew.model;
                            
                            // Match Product IDs
                            var matchedProductIds = products
                                .filter(function(product) {
                                    return product.Year === year &&
                                           product.Make === make &&
                                           product.Model === model;
                                })
                                .map(function(product) {
                                    return product['Custom Product ID'] || product['Product ID'];
                                });

                            // Match Universal Product IDs
                            var universalProductIds = products
                                .filter(function(product) {
                                    return product.Year === 'Universal' &&
                                           product.Make === 'Universal' &&
                                           product.Model === 'Universal';
                                })
                                .map(function(product) {
                                    return product['Custom Product ID'] || product['Product ID'];
                                });

                            // Combine matched product IDs and universal product IDs
                            var allMatchedProductIds = matchedProductIds.concat(universalProductIds);
                            
                            if (allMatchedProductIds.length > 0) {
                                // Store matched product IDs in local storage
                                localStorage.setItem('matchedProductIds', JSON.stringify(allMatchedProductIds));
                                console.log('Stored matched product IDs:', allMatchedProductIds);
                            } else {
                                console.log('No matching products found.');
                            }
                        } else {
                            console.log('No data found in selectedData.');
                        }
                    }
                });
            });
        }, 2000);
    });


//Collection Filter Code 

        $(document).ready(function() {
    const debugMode = true; // Set to true to enable debug mode

    function updateProductData() {
        // Load the CSV file
        $.ajax({
            url: 'https://cdn.shopify.com/s/files/1/0867/6088/2464/files/all_product_fitment_202503051311.csv?v=1742995172',
            dataType: 'text',
        }).done(function(data) {
            // if (debugMode) console.log('CSV data loaded successfully');

            // Parse the CSV file
            let lines = data.split('\n');
            let headers = lines[0].split(',');
            let products = {};

            // if (debugMode) console.log('CSV Headers:', headers);

            // Assuming the product ID is in column number 8 and custom product ID is in column number 9
            for (let i = 1; i < lines.length; i++) {
                let values = lines[i].split(',');

                if (values.length > 9) {
                    let productId = values[7];
                    let customProductId = values[8];
                    let year = values[0];
                    let make = values[1];
                    let model = values[2];

                    let idToUse = customProductId ? customProductId : productId;

                    if (!products[idToUse]) {
                        products[idToUse] = {
                            years: new Set(),
                            makes: new Set(),
                            models: new Set()
                        };
                    }

                    products[idToUse].years.add(year);
                    products[idToUse].makes.add(make);
                    products[idToUse].models.add(model);

                    // if (debugMode) console.log(`Parsed product - ID: ${idToUse}, Year: ${year}, Make: ${make}, Model: ${model}`);
                } else {
                    // if (debugMode) console.warn(`Line ${i + 1} skipped due to insufficient columns:`, values);
                }
            }

            // Update the HTML
            $('#product-grid li').each(function() {
                let productId = $(this).attr('id');
                if (products[productId]) {
                    $(this).attr('data-year', Array.from(products[productId].years).join(', '));
                    $(this).attr('data-make', Array.from(products[productId].makes).join(', '));
                    $(this).attr('data-model', Array.from(products[productId].models).join(', '));

                    // if (debugMode) console.log(`Updated HTML for Product ID ${productId}: Year=${Array.from(products[productId].years).join(', ')}, Make=${Array.from(products[productId].makes).join(', ')}, Model=${Array.from(products[productId].models).join(', ')}`);
                } else {
                    // if (debugMode) console.warn(`Product ID ${productId} not found in CSV data`);
                }
            });
        }).fail(function() {
            // if (debugMode) console.error('Failed to load CSV data');
        });
    }

    // Run the updateProductData function every second
    setInterval(updateProductData, 1000);
});























